import userInfo from "../../function/userInfo";
import i18n from "../../locales/i18n";
import * as API from "../ApiConfig";
import tableFacade from "./tableFacade";
export default {
  //#region Import
  DoGetImportTable(input) {
    let _input = tableFacade.GetImportTableInput(input);
    return API.peakAPI.post("/api/Table/GetImportTable", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  //#endregion
  //#region Contact
  DoGetContactTable(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      language: i18n.locale,
      tableContactView: {
        tableStatus: input.tableStatus,
        searchText: input.searchText,
        tableSorting: input.tableSorting,
        contactTableView: input.contactTableView,
        contactGroupId: input.contactGroupId,
        contactFinanceType: input.contactFinanceType,
        pageNo: input.pageNo,
        pageSize: input.pageSize,
      },
    };
    return API.peakAPI.post("/api/Table/GetContactTableForNewPeak", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoGetContactGroupList() {
    let _input = {
      merchantId: userInfo.MerchantId(),
    };
    return API.peakAPI.post("/api/Table/GetContactGroupList", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  //#endregion
  //#region Product
  DoGetProductTable(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      language: i18n.locale,
      tableProductView: {
        tableStatus: input.tableStatus,
        searchText: "",
        tableSorting: input.tableSorting,
        productTableView: input.transactionTableView,
        year: "2020",
        pageNo: input.pageNo,
        pageSize: input.pageSize,
      },
    };

    return API.peakAPI.post("/api/Table/GetProductTable", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoGetProductTableCount(searchText) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      language: i18n.locale,
      searchText: "",
    };
    return API.peakAPI.post("/api/Table/GetProductTableCount", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoGetUnitTable(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      language: i18n.locale,
      unitType: input.unitType,
      pageNo: input.pageNo,
      pageSize: input.pageSize,
      isDeleted: false,
      isUseMainDatabase: input.isUseMainDatabase,
    };

    return API.peakAPI.post("/api/Product/GetUnitTable", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },

  //#endregion
  //#region Finance
  DoGetPaymentTransactionTable(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      language: i18n.locale,
      bankAccountId: input.bankAccountId,
      pageNumber: input.pageNumber,
      pageSize: input.pageSize,
      isOrderDesc: input.isOrderDesc,
      fromDate: input.fromDate,
      toDate: input.toDate,
      searchText: input.searchText,
      isReconciled: input.isReconciled,
    };
    return API.peakAPI
      .post("/api/Table/GetPaymentTransactionTable", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetChequeAbleToReceiveTable(paymentInOutFlowType, rowNumber) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      language: i18n.locale,
      rowNumber: rowNumber,
      paymentInOutFlowType: paymentInOutFlowType,
    };
    return API.peakAPI
      .post("/api/Table/GetChequeAbleToReceiveTable", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetChequeWaitingReceiveTable(paymentInOutFlowType, rowNumber) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      language: i18n.locale,
      rowNumber: rowNumber,
      paymentInOutFlowType: paymentInOutFlowType,
    };
    return API.peakAPI
      .post("/api/Table/GetChequeWaitingReceiveTable", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetReceivedChequeTable(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      language: i18n.locale,
      paymentInOutFlowType: input.paymentInOutFlowType,
      chequeSearch: {
        dateType: input.dateType,
        fromDate: input.fromDate,
        toDate: input.toDate,
        searchContactName: input.searchContactName,
        searchTransactionNumber: input.searchTransactionNumber,
        searchBankAccountName: input.searchBankAccountName,
        searchChequeCode: input.searchChequeCode,
        fromNetAmount: input.fromNetAmount,
        toNetAmount: input.toNetAmount,
        orderText: input.orderText,
        pageNo: input.pageNo,
        pageSize: input.pageSize,
      },
    };
    return API.peakAPI.post("/api/Table/GetReceivedChequeTable", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoGetChequeCount(paymentInOutFlowType) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      language: i18n.locale,
      paymentInOutFlowType: paymentInOutFlowType,
    };
    return API.peakAPI.post("/api/Table/GetChequeCount", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  //#endregion
  //#region account
  DoGetJournalTable(input) {
    let _input = tableFacade.GetJournalTableRequest(input);
    return API.peakAPI.post("/api/Table/GetJournalTable", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoGetJournalTableAdvanceSearch(input) {
    let _input = tableFacade.GetJournalTableAdvanceSearchRequest(input);
    return API.peakAPI
      .post("/api/Table/GetJournalTableAdvanceSearch", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetJournalTableVeryAdvanceSearch(input) {
    let _input = tableFacade.GetJournalTableVeryAdvanceSearchRequest(input);
    return API.peakAPI
      .post("/api/Table/GetJournalTableVeryAdvanceSearch", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetJournalTableCount(input) {
    let _input = tableFacade.GetJournalTableCountRequest(input);
    return API.peakAPI.post("/api/Table/GetJournalTableCount", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoGetJournalTableCountAdvanceSearch(input) {
    let _input = tableFacade.GetJournalTableCountAdvanceSearchRequest(input);
    return API.peakAPI
      .post("/api/Table/GetJournalTableCountAdvanceSearch", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetJournalTableCountVeryAdvanceSearch(input) {
    let _input = tableFacade.GetJournalTableCountVeryAdvanceSearchRequest(input);
    return API.peakAPI
      .post("/api/Table/GetJournalTableCountVeryAdvanceSearch", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },

  DoUpdateJournalStatus(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      journalId: input.journalId,
      statusId: input.status,
    };
    return API.peakRealTimeAPI
      .post("/api/Journal/UpdateJournalStatus", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoUpdateQuotationStatus(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      transactionId: input.transactionId,
      status: input.status,
    };
    return API.peakRealTimeAPI
      .post("/api/Quotation/UpdateQuotationStatus", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoUpdateAcceptedQuotation(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      transactionId: input.transactionId,
      date: input.date,
    };
    return API.peakRealTimeAPI
      .post("/api/Quotation/UpdateAcceptedQuotation", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoUpdateInvoiceStatus(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      transactionId: input.transactionId,
      status: input.status,
      language: i18n.locale,
    };
    return API.peakRealTimeAPI
      .post("/api/Invoice/UpdateInvoiceStatus", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoUpdateExpenseStatusGotReceiptList(expenseGotReceiptListModel) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      expenseGotReceiptListModel: expenseGotReceiptListModel,
    };
    return API.peakRealTimeAPI
      .post("/api/Invoice/UpdateExpenseStatusGotReceiptList", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoUpdateReceiptStatus(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      transactionId: input.transactionId,
      status: input.status,
      language: i18n.locale,
    };
    return API.peakRealTimeAPI
      .post("/api/Receipt/UpdateReceiptStatus", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoUpdateTaxInvoiceStatus(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      transactionId: input.transactionId,
      status: input.status,
      language: i18n.locale,
    };
    return API.peakRealTimeAPI
      .post("/api/TaxInvoice/UpdateTaxInvoiceStatus", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoUpdateCreditNoteStatus(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      transactionId: input.transactionId,
      status: input.status,
      language: i18n.locale,
    };
    return API.peakRealTimeAPI
      .post("/api/CreditNote/UpdateCreditNoteStatus", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoUpdateDebitNoteStatus(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      transactionId: input.transactionId,
      status: input.status,
      language: i18n.locale,
    };
    return API.peakRealTimeAPI
      .post("/api/DebitNote/UpdateDebitNoteStatus", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoUpdateBillingNoteStatus(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      transactionId: input.transactionId,
      status: input.status,
    };
    return API.peakRealTimeAPI
      .post("/api/BillingNote/UpdateBillingNoteStatus", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  //#endregion
  //#region UploadDocument
  DoGetUploadDocumentTable(input) {
    let _input = tableFacade.GetUploadDocumentTableInput(input);
    return API.peakAPI
      .post("/api/UploadDocument/GetUploadDocumentTable", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetUploadDocumentTableCount(input) {
    let _input = tableFacade.GetUploadDocumentTableInput(input);
    return API.peakAPI
      .post("/api/UploadDocument/GetUploadDocumentTableCount", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetInvoiceForReferenceUploadDocumentTable(input) {
    let _input = tableFacade.GetInvoiceForReferenceUploadDocumentTableInput(input);
    return API.peakAPI
      .post("/api/UploadDocument/GetInvoiceForReferenceUploadDocumentTable", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetCountInvoiceForReferenceUploadDocumentTable(input) {
    let _input = tableFacade.GetInvoiceForReferenceUploadDocumentTableInput(input);
    return API.peakAPI
      .post("/api/UploadDocument/GetCountInvoiceForReferenceUploadDocumentTable", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetQuotationForReferenceUploadDocumentTable(input) {
    let _input = tableFacade.GetQuotationForReferenceUploadDocumentTableInput(input);
    return API.peakAPI
      .post("/api/UploadDocument/GetQuotationForReferenceUploadDocumentTable", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetCountQuotationForReferenceUploadDocumentTable(input) {
    let _input = tableFacade.GetQuotationForReferenceUploadDocumentTableInput(input);
    return API.peakAPI
      .post("/api/UploadDocument/GetCountQuotationForReferenceUploadDocumentTable", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetReceiptForReferenceUploadDocumentTable(input) {
    let _input = tableFacade.GetReceiptForReferenceUploadDocumentTableInput(input);
    return API.peakAPI
      .post("/api/UploadDocument/GetReceiptForReferenceUploadDocumentTable", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetCountReceiptForReferenceUploadDocumentTable(input) {
    let _input = tableFacade.GetReceiptForReferenceUploadDocumentTableInput(input);
    return API.peakAPI
      .post("/api/UploadDocument/GetCountReceiptForReferenceUploadDocumentTable", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetWhtForReferenceUploadDocumentTable(input) {
    let _input = tableFacade.GetWhtForReferenceUploadDocumentTableInput(input);
    return API.peakAPI
      .post("/api/UploadDocument/GetWhtForReferenceUploadDocumentTable", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetCountWhtForReferenceUploadDocumentTable(input) {
    let _input = tableFacade.GetWhtForReferenceUploadDocumentTableInput(input);
    return API.peakAPI
      .post("/api/UploadDocument/GetCountWhtForReferenceUploadDocumentTable", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  //#endregion
  //#region Recurring
  DoGetRecurringTableTable(input) {
    let _input = tableFacade.GetRecurringTableInput(input);
    return API.peakAPI.post("/api/Table/GetRecurringTable", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  //#endregion
  //#region CashBank
  DoGetCashBankList(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      referenceTypeId: input.referenceTypeId,
      dateTime: input.dateTime,
      language: i18n.locale,
      accountTypeId: input.accountTypeId,
      isUseMainDatabase: input.isUseMainDatabase,
    };
    return API.peakAPI.post("/api/Finance/GetCashBankList", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoGetFinanceDetailTable(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      fromDate: input.fromDate,
      toDate: input.toDate,
      journalAccountRefTypeId: input.journalAccountRefTypeId,
      journalAccountRefId: input.journalAccountRefId,
      orderBy: input.orderBy,
      filterReconcile: input.filterReconcile,
      pageNumber: input.pageNumber,
      pageSize: input.pageSize,
      searchText: input.searchText,
      sortType: input.sortType,
      accountId: input.accountId,
      isUseMainDatabase: input.isUseMainDatabase,
    };
    return API.peakAPI.post("/api/Finance/GetFinanceJournalDetail", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoGetSummaryTableAccountFinance(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      fromDate: input.fromDate,
      toDate: input.toDate,
      journalAccountRefTypeId: input.journalAccountRefTypeId,
      journalAccountRefId: input.journalAccountRefId,
      accountId: input.accountId,
    };
    return API.peakAPI
      .post("/api/Finance/GetSummaryTableAccountFinance", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetChequeTable(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      language: i18n.locale,
      pageNo: input.pageNo,
      pageSize: input.pageSize,
      fromDate: input.fromDate,
      toDate: input.toDate,
      searchText: input.searchText,
      paymentInOutFlowType: input.paymentInOutFlowType,
      isReceived: input.isReceived,
      sortBy: input.sortBy,
      sortType: input.sortType,
      isUseMainDatabase: input.isUseMainDatabase,
    };
    return API.peakAPI
      .post("/api/Table/GetChequeAbleToReceiveTable", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetChequePayment(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      language: i18n.locale,
      paymentInOutFlowTypeId: input.paymentInOutFlowTypeId,
      isUseMainDatabase: input.isUseMainDatabase,
    };
    return API.peakAPI.post("/api/Finance/GetChequeNotReceived", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  GetPaymentBankStatementsByAccountId(input) {
    const params = tableFacade.GetPaymentBankStatementsByAccountIdParams(input);
    const headers = userInfo.SetHeaderService().headers;
    return API.peakAPI
      .get("/api/PaymentBankStatement/GetPaymentBankStatementsByAccountId/" + input.bankAccountId, { params, headers })
      .then((res) => {
        return res;
      });
  },
  DoGetSummaryTableBankStatement(input) {
    const params = tableFacade.GetSummaryTableBankStatementParams(input);
    const headers = userInfo.SetHeaderService().headers;
    return API.peakAPI
      .get("/api/PaymentBankStatement/GetSummaryTableBankStatement/" + input.bankAccountId, { params, headers })
      .then((res) => {
        return res;
      });
  },
  ValidateIsCanDeleteFinance(bankAccountId) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      bankAccountId: bankAccountId,
    };
    return API.peakRealTimeAPI
      .post("/api/Finance/ValidateIsCanDeleteFinance", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DeleteBankAccount(bankAccountId) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      bankAccountId: bankAccountId,
    };
    return API.peakRealTimeAPI
      .post("/api/Finance/DeleteBankAccount", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetCashBankListForGraph(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      bankAccountId: input.bankAccountId,
      accountId: input.accountId,
      dateTime: input.dateTime,
      periodTypeId: input.periodTypeId,
      language: i18n.locale,
      isUseMainDatabase: input.isUseMainDatabase,
    };
    return API.peakAPI.post("/api/Finance/GetCashBankListForGraph", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoEditRemarkCashBankDetail(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      peakPaymentId: input.id,
      remark: input.remark,
    };
    return API.peakRealTimeAPI
      .post("/api/Finance/EditRemarkCashBankDetail", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoEditRemarkPaymentBankStatement(input) {
    let _input = {
      id: input.id,
      remark: input.remark,
    };
    return API.peakRealTimeAPI.put("/api/PaymentBankStatement", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoGetJournalAccountListByBankAccountId(input) {
    const params = tableFacade.GetJournalAccountListByBankAccountIdParams(input);
    const headers = userInfo.SetHeaderService().headers;
    return API.peakAPI
      .get("/api/JournalAccount/ByBankAccount/" + input.bankAccountId, { params, headers })
      .then((res) => {
        return res;
      });
  },
  DoGetBankReconciledByBankAccountId(input) {
    const params = tableFacade.GetBankReconciledByBankAccountIdParams(input);
    const headers = userInfo.SetHeaderService().headers;
    return API.peakAPI
      .get("/api/BankReconciled/ByBankAccount/" + input.bankAccountId, { params, headers })
      .then((res) => {
        return res;
      });
  },
  //#endregion
  //#region Wht
  DoGetWhtTable(input) {
    let _input = tableFacade.GetWhtTableList(input);
    return API.peakAPI.post("/api/Table/GetWhtTableList", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  //#endregion
  //#region setting
  DoGetUserTable(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      pageNumber: input.pageNo,
      pageSize: input.pageSize,
      searchText: input.searchText,
      userOrderBy: input.transactionTableView,
      tableSorting: input.tableSorting,
    };
    return API.peakAPI.post("/api/User/GetUserTable", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  //#endregion
  //#region allocation
  DoGetAllocationTableList(input) {
    let _input = {
      data: {
        merchantId: userInfo.MerchantId(),
        pageNo: input.pageNo,
        pageSize: input.pageSize,
        isUseMainDatabase: input.isUseMainDatabase,
        searchText: input.searchText,
        sortingTypeId: input.sortingTypeId,
        orderColumnTypeId: input.orderColumnTypeId,
      },
    };
    return API.peakAPI.post("/api/Table/GetAllocationTableList", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  //#endregion
  DoGetNewProductTable(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      language: i18n.locale,
      isUseMainDatabase: input.isUseMainDatabase,
      productTableSearchCriteria: {
        type: input.type,
        isArchived: input.isArchived,
        pageNo: input.pageNo,
        pageSize: input.pageSize,
        orderRowType: input.orderRowType,
        sortingType: input.tableSorting,
        searchText: input.searchText,
      },
    };
    return API.peakAPI.post("/api/Table/GetNewProductTable", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoGetServiceTable(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      language: i18n.locale,
      isUseMainDatabase: input.isUseMainDatabase,
      productTableSearchCriteria: {
        type: input.type,
        isArchived: input.isArchived,
        pageNo: input.pageNo,
        pageSize: input.pageSize,
        orderRowType: input.orderRowType,
        sortingType: input.tableSorting,
        searchText: input.searchText,
      },
    };
    return API.peakAPI.post("/api/Table/GetNewProductTable", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoGetLotTableByLotSequenceNumber(input) {
    const headers = userInfo.SetHeaderService().headers;
    const params = { productTemplateId: input.productTemplateId, lotSequenceNumber: input.lotSequenceNumber };

    return API.peakAPI.get("/api/Product/GetLotTableByLotSequenceNumber", { params, headers }).then((res) => {
      return res;
    });
  },
  DoGetStockActivityTable(input) {
    let _input = tableFacade.GetStockActivityTableRequest(input);
    return API.peakAPI.post("/api/Product/GetStockActivityTable", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoGetStockActivityTableCount(input) {
    let _input = tableFacade.GetStockActivityTableCountRequest(input);
    return API.peakAPI
      .post("/api/Product/GetStockActivityTableCount", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetInvoiceForCreateBillingNoteTable(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      createBillingNoteSearchCriteria: {
        contactId: input.contactId,
        pageNo: input.pageNo,
        pageSize: input.pageSize,
        tableSorting: input.tableSorting,
        transactionTableView: input.transactionTableView,
        financeType: input.financeType,
        editBillingNoteId: input.editBillingNoteId,
      },
      isUseMainDatabase: input.isUseMainDatabase,
    };
    return API.peakAPI
      .post("/api/Table/GetInvoiceForCreateBillingNoteTable", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetInvoiceNumberListReferenceQuotation(input) {
    let _input = {
      quotationIdList: input.quotationIdList,
      financeType: input.financeType,
    };
    return API.peakAPI
      .post("/api/Table/GetInvoiceNumberListReferenceQuotation", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  //#region InoviceTable
  DoGetInvoiceTable(input) {
    let _input = tableFacade.GetInvoiceTableRequest(input);
    return API.peakAPI.post("/api/Table/GetInvoiceTable", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoGetInvoiceTableAdvanceSearch(input) {
    let _input = tableFacade.GetInvoiceTableAdvanceSearchRequest(input);
    return API.peakAPI
      .post("/api/Table/GetInvoiceTableAdvanceSearch", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetInvoiceTableVeryAdvanceSearch(input) {
    let _input = tableFacade.GetInvoiceTableVeryAdvanceSearchRequest(input);
    return API.peakAPI
      .post("/api/Table/GetInvoiceTableVeryAdvanceSearch", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetInvoiceTableCount(input) {
    let _input = tableFacade.GetInvoiceTableCountRequest(input);
    return API.peakAPI.post("/api/Table/GetInvoiceTableCount", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoGetInvoiceTableCountAdvanceSearch(input) {
    let _input = tableFacade.GetInvoiceTableCountAdvanceSearchRequest(input);
    return API.peakAPI
      .post("/api/Table/GetInvoiceTableCountAdvanceSearch", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetInvoiceTableCountVeryAdvanceSearch(input) {
    let _input = tableFacade.GetInvoiceTableCountVeryAdvanceSearchRequest(input);
    return API.peakAPI
      .post("/api/Table/GetInvoiceTableCountVeryAdvanceSearch", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  //#endregion
  //#region ExpenseTable
  DoGetExpenseTable(input) {
    let _input = tableFacade.GetExpenseTableRequest(input);
    return API.peakAPI.post("/api/Table/GetExpenseTable", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoGetExpenseTableAdvanceSearch(input) {
    let _input = tableFacade.GetExpenseTableAdvanceSearchRequest(input);
    return API.peakAPI
      .post("/api/Table/GetExpenseTableAdvanceSearch", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetExpenseTableVeryAdvanceSearch(input) {
    let _input = tableFacade.GetExpenseTableVeryAdvanceSearchRequest(input);
    return API.peakAPI
      .post("/api/Table/GetExpenseTableVeryAdvanceSearch", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetExpenseTableCount(input) {
    let _input = tableFacade.GetExpenseTableCountRequest(input);
    return API.peakAPI.post("/api/Table/GetExpenseTableCount", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoGetExpenseTableCountAdvanceSearch(input) {
    let _input = tableFacade.GetExpenseTableCountAdvanceSearchRequest(input);
    return API.peakAPI
      .post("/api/Table/GetExpenseTableCountAdvanceSearch", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetExpenseTableCountVeryAdvanceSearch(input) {
    let _input = tableFacade.GetExpenseTableCountVeryAdvanceSearchRequest(input);
    return API.peakAPI
      .post("/api/Table/GetExpenseTableCountVeryAdvanceSearch", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  //#endregion
  //#region PurchaseAssetTable
  DoGetPurchaseAssetTable(input) {
    let _input = tableFacade.GetPurchaseAssetTableRequest(input);
    return API.peakAPI.post("/api/Table/GetPurchaseAssetTable", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoGetPurchaseAssetTableAdvanceSearch(input) {
    let _input = tableFacade.GetPurchaseAssetTableAdvanceSearchRequest(input);
    return API.peakAPI
      .post("/api/Table/GetPurchaseAssetTableAdvanceSearch", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetPurchaseAssetTableVeryAdvanceSearch(input) {
    let _input = tableFacade.GetPurchaseAssetTableVeryAdvanceSearchRequest(input);
    return API.peakAPI
      .post("/api/Table/GetPurchaseAssetTableVeryAdvanceSearch", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetPurchaseAssetTableCount(input) {
    let _input = tableFacade.GetPurchaseAssetTableRequest(input);
    return API.peakAPI
      .post("/api/Table/GetPurchaseAssetTableCount", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetPurchaseAssetTableCountAdvanceSearch(input) {
    let _input = tableFacade.GetPurchaseAssetTableCountAdvanceSearchRequest(input);
    return API.peakAPI
      .post("/api/Table/GetPurchaseAssetTableCountAdvanceSearch", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetPurchaseAssetTableCountVeryAdvanceSearch(input) {
    let _input = tableFacade.GetPurchaseAssetTableCountVeryAdvanceSearchRequest(input);
    return API.peakAPI
      .post("/api/Table/GetPurchaseAssetTableCountVeryAdvanceSearch", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  //#endregion
  //#region QuotationTable
  DoGetQuotationTable(input) {
    let _input = tableFacade.GetQuotationTableRequest(input);
    return API.peakAPI.post("/api/Table/GetQuotationTable", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoGetQuotationTableAdvanceSearch(input) {
    let _input = tableFacade.GetQuotationTableAdvanceSearchRequest(input);
    return API.peakAPI
      .post("/api/Table/GetQuotationTableAdvanceSearch", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetQuotationTableVeryAdvanceSearch(input) {
    let _input = tableFacade.GetQuotationTableVeryAdvanceSearchRequest(input);
    return API.peakAPI
      .post("/api/Table/GetQuotationTableVeryAdvanceSearch", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetQuotationTableCount(input) {
    let _input = tableFacade.GetQuotationTableCountRequest(input);
    return API.peakAPI.post("/api/Table/GetQuotationTableCount", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoGetQuotationTableCountAdvanceSearch(input) {
    let _input = tableFacade.GetQuotationTableCountAdvanceSearchRequest(input);
    return API.peakAPI
      .post("/api/Table/GetQuotationTableCountAdvanceSearch", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetQuotationTableCountVeryAdvanceSearch(input) {
    let _input = tableFacade.GetQuotationTableCountVeryAdvanceSearchRequest(input);
    return API.peakAPI
      .post("/api/Table/GetQuotationTableCountVeryAdvanceSearch", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  //#endregion
  //#region PurchaseOrderTable
  DoGetPurchaseOrderTable(input) {
    let _input = tableFacade.GetPurchaseOrderTableRequest(input);
    return API.peakAPI.post("/api/Table/GetPurchaseOrderTable", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoGetPurchaseOrderTableAdvanceSearch(input) {
    let _input = tableFacade.GetPurchaseOrderTableAdvanceSearchRequest(input);
    return API.peakAPI
      .post("/api/Table/GetPurchaseOrderTableAdvanceSearch", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetPurchaseOrderTableVeryAdvanceSearch(input) {
    let _input = tableFacade.GetPurchaseOrderTableVeryAdvanceSearchRequest(input);
    return API.peakAPI
      .post("/api/Table/GetPurchaseOrderTableVeryAdvanceSearch", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetPurchaseOrderTableCount(input) {
    let _input = tableFacade.GetPurchaseOrderTableCountRequest(input);
    return API.peakAPI
      .post("/api/Table/GetPurchaseOrderTableCount", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetPurchaseOrderTableCountAdvanceSearch(input) {
    let _input = tableFacade.GetPurchaseOrderTableCountAdvanceSearchRequest(input);
    return API.peakAPI
      .post("/api/Table/GetPurchaseOrderTableCountAdvanceSearch", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetPurchaseOrderTableCountVeryAdvanceSearch(input) {
    let _input = tableFacade.GetPurchaseOrderTableCountVeryAdvanceSearchRequest(input);
    return API.peakAPI
      .post("/api/Table/GetPurchaseOrderTableCountVeryAdvanceSearch", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  //#endregion
  //#region PurchaseOrderAssetTable
  DoGetPurchaseOrderAssetTable(input) {
    let _input = tableFacade.GetPurchaseOrderAssetTableRequest(input);
    return API.peakAPI
      .post("/api/Table/GetPurchaseOrderAssetTable", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetPurchaseOrderAssetTableAdvanceSearch(input) {
    let _input = tableFacade.GetPurchaseOrderAssetTableAdvanceSearchRequest(input);
    return API.peakAPI
      .post("/api/Table/GetPurchaseOrderAssetTableAdvanceSearch", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetPurchaseOrderAssetTableVeryAdvanceSearch(input) {
    let _input = tableFacade.GetPurchaseOrderAssetTableVeryAdvanceSearchRequest(input);
    return API.peakAPI
      .post("/api/Table/GetPurchaseOrderAssetTableVeryAdvanceSearch", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetPurchaseOrderAssetTableCount(input) {
    let _input = tableFacade.GetPurchaseOrderAssetTableCountRequest(input);
    return API.peakAPI
      .post("/api/Table/GetPurchaseOrderAssetTableCount", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetPurchaseOrderAssetTableCountAdvanceSearch(input) {
    let _input = tableFacade.GetPurchaseOrderAssetTableCountAdvanceSearchRequest(input);
    return API.peakAPI
      .post("/api/Table/GetPurchaseOrderAssetTableCountAdvanceSearch", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetPurchaseOrderAssetTableCountVeryAdvanceSearch(input) {
    let _input = tableFacade.GetPurchaseOrderAssetTableCountVeryAdvanceSearchRequest(input);
    return API.peakAPI
      .post("/api/Table/GetPurchaseOrderAssetTableCountVeryAdvanceSearch", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  //#endregion
  //#region ReceiptTable
  DoGetReceiptTable(input) {
    let _input = tableFacade.GetReceiptTableRequest(input);
    return API.peakAPI.post("/api/Table/GetReceiptTable", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoGetReceiptTableAdvanceSearch(input) {
    let _input = tableFacade.GetReceiptTableAdvanceSearchRequest(input);
    return API.peakAPI
      .post("/api/Table/GetReceiptTableAdvanceSearch", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetReceiptTableVeryAdvanceSearch(input) {
    let _input = tableFacade.GetReceiptTableVeryAdvanceSearchRequest(input);
    return API.peakAPI
      .post("/api/Table/GetReceiptTableVeryAdvanceSearch", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetReceiptTableCount(input) {
    let _input = tableFacade.GetReceiptTableCountRequest(input);
    return API.peakAPI.post("/api/Table/GetReceiptTableCount", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoGetReceiptTableCountAdvanceSearch(input) {
    let _input = tableFacade.GetReceiptTableCountAdvanceSearchRequest(input);
    return API.peakAPI
      .post("/api/Table/GetReceiptTableCountAdvanceSearch", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetReceiptTableCountVeryAdvanceSearch(input) {
    let _input = tableFacade.GetReceiptTableCountVeryAdvanceSearchRequest(input);
    return API.peakAPI
      .post("/api/Table/GetReceiptTableCountVeryAdvanceSearch", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  //#endregion
  //#region TaxInvoiceTable
  DoGetTaxInvoiceTable(input) {
    let _input = tableFacade.GetTaxInvoiceTableRequest(input);
    return API.peakAPI.post("/api/Table/GetTaxInvoiceTable", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoGetTaxInvoiceTableAdvanceSearch(input) {
    let _input = tableFacade.GetTaxInvoiceTableAdvanceSearchRequest(input);
    return API.peakAPI
      .post("/api/Table/GetTaxInvoiceTableAdvanceSearch", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetTaxInvoiceTableVeryAdvanceSearch(input) {
    let _input = tableFacade.GetTaxInvoiceTableVeryAdvanceSearchRequest(input);
    return API.peakAPI
      .post("/api/Table/GetTaxInvoiceTableVeryAdvanceSearch", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetTaxInvoiceTableCount(input) {
    let _input = tableFacade.GetTaxInvoiceTableCountRequest(input);
    return API.peakAPI.post("/api/Table/GetTaxInvoiceTableCount", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoGetTaxInvoiceTableCountAdvanceSearch(input) {
    let _input = tableFacade.GetTaxInvoiceTableCountAdvanceSearchRequest(input);
    return API.peakAPI
      .post("/api/Table/GetTaxInvoiceTableCountAdvanceSearch", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetTaxInvoiceTableCountVeryAdvanceSearch(input) {
    let _input = tableFacade.GetTaxInvoiceTableCountVeryAdvanceSearchRequest(input);
    return API.peakAPI
      .post("/api/Table/GetTaxInvoiceTableCountVeryAdvanceSearch", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  //#endregion
  //#region PurchaseTaxInvoiceTable
  DoGetPurchaseTaxInvoiceTable(input) {
    let _input = tableFacade.GetPurchaseTaxInvoiceTableRequest(input);
    return API.peakAPI
      .post("/api/Table/GetPurchaseTaxInvoiceTable", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetPurchaseTaxInvoiceTableAdvanceSearch(input) {
    let _input = tableFacade.GetPurchaseTaxInvoiceTableAdvanceSearchRequest(input);
    return API.peakAPI
      .post("/api/Table/GetPurchaseTaxInvoiceTableAdvanceSearch", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetPurchaseTaxInvoiceTableVeryAdvanceSearch(input) {
    let _input = tableFacade.GetPurchaseTaxInvoiceTableVeryAdvanceSearchRequest(input);
    return API.peakAPI
      .post("/api/Table/GetPurchaseTaxInvoiceTableVeryAdvanceSearch", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetPurchaseTaxInvoiceTableCount(input) {
    let _input = tableFacade.GetPurchaseTaxInvoiceTableCountRequest(input);
    return API.peakAPI
      .post("/api/Table/GetPurchaseTaxInvoiceTableCount", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetPurchaseTaxInvoiceTableCountAdvanceSearch(input) {
    let _input = tableFacade.GetPurchaseTaxInvoiceTableCountAdvanceSearchRequest(input);
    return API.peakAPI
      .post("/api/Table/GetPurchaseTaxInvoiceTableCountAdvanceSearch", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetPurchaseTaxInvoiceTableCountVeryAdvanceSearch(input) {
    let _input = tableFacade.GetPurchaseTaxInvoiceTableCountVeryAdvanceSearchRequest(input);
    return API.peakAPI
      .post("/api/Table/GetPurchaseTaxInvoiceTableCountVeryAdvanceSearch", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  //#endregion
  //#region CreditNoteTable
  DoGetCreditNoteTable(input) {
    let _input = tableFacade.GetCreditNoteTableRequest(input);
    return API.peakAPI.post("/api/Table/GetCreditNoteTable", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoGetCreditNoteTableAdvanceSearch(input) {
    let _input = tableFacade.GetCreditNoteTableAdvanceSearchRequest(input);
    return API.peakAPI
      .post("/api/Table/GetCreditNoteTableAdvanceSearch", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetCreditNoteTableVeryAdvanceSearch(input) {
    let _input = tableFacade.GetCreditNoteTableVeryAdvanceSearchRequest(input);
    return API.peakAPI
      .post("/api/Table/GetCreditNoteTableVeryAdvanceSearch", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetCreditNoteTableCount(input) {
    let _input = tableFacade.GetCreditNoteTableCountRequest(input);
    return API.peakAPI.post("/api/Table/GetCreditNoteTableCount", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoGetCreditNoteTableCountAdvanceSearch(input) {
    let _input = tableFacade.GetCreditNoteTableCountAdvanceSearchRequest(input);
    return API.peakAPI
      .post("/api/Table/GetCreditNoteTableCountAdvanceSearch", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetCreditNoteTableCountVeryAdvanceSearch(input) {
    let _input = tableFacade.GetCreditNoteTableCountVeryAdvanceSearchRequest(input);
    return API.peakAPI
      .post("/api/Table/GetCreditNoteTableCountVeryAdvanceSearch", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  //#endregion
  //#region ReceivedCreditNoteTable
  DoGetReceivedCreditNoteTable(input) {
    let _input = tableFacade.GetReceivedCreditNoteTableRequest(input);
    return API.peakAPI
      .post("/api/Table/GetReceivedCreditNoteTable", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetReceivedCreditNoteTableAdvanceSearch(input) {
    let _input = tableFacade.GetReceivedCreditNoteTableAdvanceSearchRequest(input);
    return API.peakAPI
      .post("/api/Table/GetReceivedCreditNoteTableAdvanceSearch", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetReceivedCreditNoteTableVeryAdvanceSearch(input) {
    let _input = tableFacade.GetReceivedCreditNoteTableVeryAdvanceSearchRequest(input);
    return API.peakAPI
      .post("/api/Table/GetReceivedCreditNoteTableVeryAdvanceSearch", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetReceivedCreditNoteTableCount(input) {
    let _input = tableFacade.GetReceivedCreditNoteTableCountRequest(input);
    return API.peakAPI
      .post("/api/Table/GetReceivedCreditNoteTableCount", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetReceivedCreditNoteTableCountAdvanceSearch(input) {
    let _input = tableFacade.GetReceivedCreditNoteTableCountAdvanceSearchRequest(input);
    return API.peakAPI
      .post("/api/Table/GetReceivedCreditNoteTableCountAdvanceSearch", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetReceivedCreditNoteTableCountVeryAdvanceSearch(input) {
    let _input = tableFacade.GetReceivedCreditNoteTableCountVeryAdvanceSearchRequest(input);
    return API.peakAPI
      .post("/api/Table/GetReceivedCreditNoteTableCountVeryAdvanceSearch", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  //#endregion
  //#region DebitNoteTable
  DoGetDebitNoteTable(input) {
    let _input = tableFacade.GetDebitNoteTableRequest(input);
    return API.peakAPI.post("/api/Table/GetDebitNoteTable", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoGetDebitNoteTableAdvanceSearch(input) {
    let _input = tableFacade.GetDebitNoteTableAdvanceSearchRequest(input);
    return API.peakAPI
      .post("/api/Table/GetDebitNoteTableAdvanceSearch", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetDebitNoteTableVeryAdvanceSearch(input) {
    let _input = tableFacade.GetDebitNoteTableVeryAdvanceSearchRequest(input);
    return API.peakAPI
      .post("/api/Table/GetDebitNoteTableVeryAdvanceSearch", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetDebitNoteTableCount(input) {
    let _input = tableFacade.GetDebitNoteTableCountRequest(input);
    return API.peakAPI.post("/api/Table/GetDebitNoteTableCount", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoGetDebitNoteTableCountAdvanceSearch(input) {
    let _input = tableFacade.GetDebitNoteTableCountAdvanceSearchRequest(input);
    return API.peakAPI
      .post("/api/Table/GetDebitNoteTableCountAdvanceSearch", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetDebitNoteTableCountVeryAdvanceSearch(input) {
    let _input = tableFacade.GetDebitNoteTableCountVeryAdvanceSearchRequest(input);
    return API.peakAPI
      .post("/api/Table/GetDebitNoteTableCountVeryAdvanceSearch", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  //#endregion
  //#region ReceivedDebitNoteTable
  DoGetReceivedDebitNoteTable(input) {
    let _input = tableFacade.GetReceivedDebitNoteTableRequest(input);
    return API.peakAPI.post("/api/Table/GetReceivedDebitNoteTable", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoGetReceivedDebitNoteTableAdvanceSearch(input) {
    let _input = tableFacade.GetReceivedDebitNoteTableAdvanceSearchRequest(input);
    return API.peakAPI
      .post("/api/Table/GetReceivedDebitNoteTableAdvanceSearch", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetReceivedDebitNoteTableVeryAdvanceSearch(input) {
    let _input = tableFacade.GetReceivedDebitNoteTableVeryAdvanceSearchRequest(input);
    return API.peakAPI
      .post("/api/Table/GetReceivedDebitNoteTableVeryAdvanceSearch", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetReceivedDebitNoteTableCount(input) {
    let _input = tableFacade.GetReceivedDebitNoteTableCountRequest(input);
    return API.peakAPI
      .post("/api/Table/GetReceivedDebitNoteTableCount", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetReceivedDebitNoteTableCountAdvanceSearch(input) {
    let _input = tableFacade.GetReceivedDebitNoteTableCountAdvanceSearchRequest(input);
    return API.peakAPI
      .post("/api/Table/GetReceivedDebitNoteTableCountAdvanceSearch", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetReceivedDebitNoteTableCountVeryAdvanceSearch(input) {
    let _input = tableFacade.GetReceivedDebitNoteTableCountVeryAdvanceSearchRequest(input);
    return API.peakAPI
      .post("/api/Table/GetReceivedDebitNoteTableCountVeryAdvanceSearch", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  //#endregion
  //#region BillingNoteTable
  DoGetBillingNoteTable(input) {
    let _input = tableFacade.GetBillingNoteTableRequest(input);
    return API.peakAPI.post("/api/Table/GetBillingNoteTable", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoGetBillingNoteTableAdvanceSearch(input) {
    let _input = tableFacade.GetBillingNoteTableAdvanceSearchRequest(input);
    return API.peakAPI
      .post("/api/Table/GetBillingNoteTableAdvanceSearch", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetBillingNoteTableVeryAdvanceSearch(input) {
    let _input = tableFacade.GetBillingNoteTableVeryAdvanceSearchRequest(input);
    return API.peakAPI
      .post("/api/Table/GetBillingNoteTableVeryAdvanceSearch", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetBillingNoteTableCount(input) {
    let _input = tableFacade.GetBillingNoteTableCountRequest(input);
    return API.peakAPI.post("/api/Table/GetBillingNoteTableCount", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoGetBillingNoteTableCountAdvanceSearch(input) {
    let _input = tableFacade.GetBillingNoteTableCountAdvanceSearchRequest(input);
    return API.peakAPI
      .post("/api/Table/GetBillingNoteTableCountAdvanceSearch", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetBillingNoteTableCountVeryAdvanceSearch(input) {
    let _input = tableFacade.GetBillingNoteTableCountVeryAdvanceSearchRequest(input);
    return API.peakAPI
      .post("/api/Table/GetBillingNoteTableCountVeryAdvanceSearch", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  //#endregion
  //#region CombinePaymentNote
  DoGetCombinePaymentNoteTable(input) {
    let _input = tableFacade.GetCombinePaymentNoteTableRequest(input);
    return API.peakAPI
      .post("/api/Table/GetCombinePaymentNoteTable", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetCombinePaymentNoteTableAdvanceSearch(input) {
    let _input = tableFacade.GetCombinePaymentNoteTableAdvanceSearchRequest(input);
    return API.peakAPI
      .post("/api/Table/GetCombinePaymentNoteTableAdvanceSearch", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetCombinePaymentNoteTableVeryAdvanceSearch(input) {
    let _input = tableFacade.GetCombinePaymentNoteTableVeryAdvanceSearchRequest(input);
    return API.peakAPI
      .post("/api/Table/GetCombinePaymentNoteTableVeryAdvanceSearch", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetCombinePaymentNoteTableCount(input) {
    let _input = tableFacade.GetCombinePaymentNoteTableCountRequest(input);
    return API.peakAPI
      .post("/api/Table/GetCombinePaymentNoteTableCount", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetCombinePaymentNoteTableCountAdvanceSearch(input) {
    let _input = tableFacade.GetCombinePaymentNoteTableCountAdvanceSearchRequest(input);
    return API.peakAPI
      .post("/api/Table/GetCombinePaymentNoteTableCountAdvanceSearch", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetCombinePaymentNoteTableCountVeryAdvanceSearch(input) {
    let _input = tableFacade.GetCombinePaymentNoteTableCountVeryAdvanceSearchRequest(input);
    return API.peakAPI
      .post("/api/Table/GetCombinePaymentNoteTableCountVeryAdvanceSearch", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  //#endregion
};
